import styled from 'styled-components';

export const FlagContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  gap: 0.25rem;
`;

export const FlagImageWrapper = styled.div`
  display: flex;
  width: 1.5rem;
`;

export const EndAdornmentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const OtpButton = styled.div<{ disabled?: boolean }>`
  font-size: 0.875rem;
  font-weight: 500;
  padding: 0.25rem 0.5rem;
  background-color: ${props => props.disabled ? '#ccc' : '#f86400'};
  color: #fff;
  border-radius: 0.25rem;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  white-space: nowrap;
  user-select: none;
  
  &:hover {
    background-color: ${props => props.disabled ? '#ccc' : '#e05800'};
  }
  
  &:active {
    background-color: ${props => props.disabled ? '#ccc' : '#d04f00'};
  }
`;

export const VerifiedIconWrapper = styled.div`
  display: flex;
  align-items: center;
  color: #22C55E;
`;

export const ChevronIcon = styled.div`
  display: flex;
  align-items: center;
  color: #64748b;
`;
